const MotorImpaired = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="46.5" cy="46.5" r="46.5" />
      <g clipPath="url(#clip0_127_3414)">
        <path
          d="M39.1732 81.7493C37.5134 81.4314 35.8238 81.228 34.1993 80.7793C25.5486 78.378 18.941 70.6837 17.9454 61.9613C16.829 52.0547 22.0764 42.9109 31.2742 38.7786C31.5831 38.6387 31.9013 38.5206 32.3162 38.3535C32.3162 39.8393 32.333 41.2144 32.2939 42.5894C32.2939 42.7565 32.0017 42.9617 31.8008 43.0725C26.8027 45.8571 23.6134 49.9658 22.3573 55.4568C20.0574 65.4888 27.2344 75.8732 37.6157 77.3699C45.8385 78.556 52.2544 75.5935 56.8728 68.8728C56.951 68.7602 57.0254 68.6475 57.1724 68.4277C57.7493 68.989 58.2889 69.5176 58.8471 70.0625C60.2669 71.4484 60.2874 71.4648 59.0146 73.0251C54.9209 78.0438 49.6158 80.9519 43.0603 81.6385C42.8784 81.6675 42.6982 81.7063 42.5207 81.7547L39.1732 81.7493Z"
          fill="black"
        />
        <path
          d="M41.828 12C42.1109 12.0836 42.3863 12.1816 42.6765 12.2525C46.0576 13.1607 48.0616 16.3521 47.4085 19.7688C46.8037 22.9348 43.6069 25.2507 40.3078 24.9128C38.7359 24.7679 37.2687 24.0798 36.1704 22.9725C35.0721 21.8652 34.415 20.4115 34.3174 18.8732C34.2197 17.3349 34.688 15.8131 35.6379 14.582C36.5878 13.3508 37.9568 12.4912 39.4983 12.158C39.6733 12.1181 39.8426 12.0527 40.0138 12H41.828Z"
          fill="black"
        />
        <path
          d="M44.8755 36.9759H46.7363C50.9454 36.9759 55.1545 36.9668 59.3654 36.9759C61.6802 36.9759 63.3046 38.182 63.781 40.1873C64.3541 42.6031 62.551 45.0099 60.0073 45.1152C58.1466 45.1933 56.2858 45.1443 54.425 45.1461H44.9146V53.4271H45.6999C50.1192 53.4271 54.5367 53.418 58.956 53.4453C59.3343 53.4553 59.6968 53.5955 59.9794 53.8412C64.8323 58.5421 69.6703 63.2575 74.4935 67.9874C76.4882 69.9401 76.3673 72.8209 74.2572 74.3448C72.5639 75.5709 70.3365 75.4347 68.7828 73.947C66.9052 72.1543 65.0612 70.3251 63.2004 68.5124C60.9973 66.3617 58.7867 64.2166 56.5984 62.0514C56.454 61.8945 56.2759 61.7707 56.0768 61.6887C55.8777 61.6068 55.6625 61.5687 55.4466 61.5773C50.167 61.5931 44.8879 61.5931 39.6095 61.5773C37.6018 61.5773 36.5039 60.5129 36.5039 58.5566C36.5039 50.0668 36.5039 41.5769 36.5039 33.087C36.5039 31.4522 37.2203 30.1898 38.694 29.4051C40.1175 28.6477 41.5652 28.7022 42.9254 29.5668C44.228 30.3987 44.8439 31.6321 44.87 33.1379C44.8923 34.4021 44.8755 35.6445 44.8755 36.9759Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_127_3414">
          <rect
            width="58.125"
            height="69.75"
            fill="white"
            transform="translate(17.793 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MotorImpaired;
